import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OverlayPanelModule } from 'primeng/primeng';
import { ButtonModule } from 'primeng/primeng';
import { SessionService } from '../services/session.service';
import { CommonDataService } from '../../shared/services/common-data.service';

import { UserService } from '../../shared/services/user.service';
import * as moment from "moment";

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['../footer-header-styles/header.footer.component.css']
})
export class HeaderComponent implements OnInit {
    isLogged: boolean;
    isExpanded: boolean = false;
    market = null;
    showTwoButtons: boolean = false;

    constructor(private sessionService: SessionService, private commonDataService: CommonDataService, private router: Router, private userService: UserService) {
        this.market = commonDataService.checkMarket();
        const currentDate = new Date();
        this.showTwoButtons = moment(currentDate).isBefore('2019-12-31 00:00:00');
    }

    ngOnInit() {
        this.isLogged = this.sessionService.isAuthenticated() || this.sessionService.haveToRefresh();
    }

    userLogout(): void {
        this.sessionService.logout();
        this.userService.userLogout()
            .subscribe(
            data => {
                this.sessionService.destroySessionCookie();
                this.router.navigate(['/']);
            },
            error => {
                this.sessionService.destroySessionCookie();
                this.router.navigate(['/']);
            }
        );
    }

    goToMyAccount() {
        if(this.sessionService.isAuthenticated()) {
            this.router.navigate(['/myaccount']);
        } else {
            //TODO maybe refresh tocken if remember me is present
            this.router.navigate(['/']);
        }
    }

    menuToggle() {
        this.isExpanded = !this.isExpanded;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/header/header.component.ts